import { useCallback, useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { latestUpdate } from '../lib/update-logs';
import { dismissUpdate, isUpdateDismissed, UPDATE_LOG_STORAGE_KEY } from '../lib/update-notices';
import { LatestUpdatePopup } from './LatestUpdatePopup';

/** Mounted on the homepage only; a new release ID announces the next update. */
export function LatestUpdateAnnouncement() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isUpdateDismissed(latestUpdate.id)) setOpen(true);
    }, 600);
    const sync = (event: StorageEvent) => {
      if (event.key === UPDATE_LOG_STORAGE_KEY && event.newValue === latestUpdate.id) setOpen(false);
    };
    window.addEventListener('storage', sync);
    return () => { clearTimeout(timer); window.removeEventListener('storage', sync); };
  }, []);
  const dismiss = useCallback(() => { dismissUpdate(latestUpdate.id); setOpen(false); }, []);
  return <>
    <button className="outline-button latest-update-trigger" type="button" onClick={() => setOpen(true)}><Sparkles size={14} />What’s new</button>
    {open && <LatestUpdatePopup entry={latestUpdate} onDismiss={dismiss} />}
  </>;
}
